import React from 'react';
import { UserProfile, InsightsResponse } from '~/lib/api.ts';

interface HomeScreenProps {
  user: UserProfile | null;
  insights: InsightsResponse | null;
  onLogClick: () => void;
  onTodayClick: () => void;
  onAIClick: () => void;
  onRefresh: () => void;
}

export const HomeScreen: React.FC<HomeScreenProps> = ({
  user,
  insights,
  onLogClick,
  onTodayClick,
  onAIClick,
  onRefresh
}) => {
  const today = insights?.today;
  const week = insights?.week;

  return (
    <div className="screen">
      <div className="header">
        <h1>🦊 NeuroFox</h1>
        <button className="refresh-button" onClick={onRefresh}>
          🔄
        </button>
      </div>

      {user && (
        <div className="user-info">
          <div className="user-level">
            <span className="level-badge">Уровень {user.level}</span>
            <span className="xp-text">{user.xp} XP</span>
          </div>
          <div className="user-name">{user.name}</div>
        </div>
      )}

      <div className="quick-stats">
        <div className="stat-card">
          <div className="stat-icon">😴</div>
          <div className="stat-value">{today?.sleep_hours || '—'}ч</div>
          <div className="stat-label">Сон</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">👟</div>
          <div className="stat-value">{today?.steps || '—'}</div>
          <div className="stat-label">Шаги</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📱</div>
          <div className="stat-value">{today?.screen_time_minutes ? Math.round(today.screen_time_minutes / 60) : '—'}ч</div>
          <div className="stat-label">Экран</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">😊</div>
          <div className="stat-value">{today?.mood_score || '—'}/5</div>
          <div className="stat-label">Настроение</div>
        </div>
      </div>

      {week && (
        <div className="weekly-summary">
          <h3>📈 За неделю</h3>
          <div className="summary-stats">
            <div className="summary-item">
              <span className="summary-label">Всего шагов:</span>
              <span className="summary-value">{week.total_steps.toLocaleString()}</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Средний сон:</span>
              <span className="summary-value">{week.avg_sleep.toFixed(1)}ч</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Дней записано:</span>
              <span className="summary-value">{week.days_logged}/7</span>
            </div>
          </div>
        </div>
      )}

      {insights?.tips && insights.tips.length > 0 && (
        <div className="tips-section">
          <h3>💡 Советы</h3>
          <div className="tips-list">
            {insights.tips.map((tip, index) => (
              <div key={index} className="tip-item">
                {tip}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="action-buttons">
        <button className="action-button primary" onClick={onLogClick}>
          📝 Записать данные
        </button>
        <button className="action-button secondary" onClick={onTodayClick}>
          📊 Сегодня
        </button>
        <button className="action-button secondary" onClick={onAIClick}>
          🧠 AI Ассистент
        </button>
      </div>
    </div>
  );
};
